import React, { FunctionComponent } from "react"
import { AppBar, Toolbar, Button } from "@material-ui/core"
import { useAuth } from "../common/hooks/useAuth"
import { useHistory } from "react-router-dom"
import styles from "./TopBar.module.scss"

export const TopBar: FunctionComponent = () => {
    const { authenticated, logout, branding } = useAuth()
    const history = useHistory()

    const imgSrc = "data:image/svg+xml;base64," + branding?.logo

    return (
        <AppBar position="static" className={styles.TopBar}>
            <Toolbar className={styles.TopBar__toolbar}>
                {authenticated && (
                    <>
                        {branding?.logo && (
                            <div id={"topbar-logo"} className={styles.TopBar__toolbar__title}>
                                <img
                                    onClick={() => history.push("/single")}
                                    data-testid="app-logo"
                                    alt={branding?.name}
                                    src={imgSrc}
                                />
                            </div>
                        )}
                        <Button
                            id="logout-btn"
                            data-testid="logout-btn"
                            color="inherit"
                            className={styles.TopBar__toolbar__logout}
                            onClick={() => {
                                logout()
                                history.push("/login")
                            }}
                        >
                            Logout
                        </Button>
                    </>
                )}
            </Toolbar>
        </AppBar>
    )
}
